import { InfoIcon } from "@src/components/elements/assets";
import React from "react";
import toast, { ToastPosition } from "react-hot-toast";

export const notifySuccess = (
  message: string,
  position?: ToastPosition,
): string => {
  return toast.success(message, {
    duration: 3000,
    position: position ? position : "top-center",
    className: "toast-success",
    style: {
      backgroundColor: "var(--green)",
      color: "var(--white)",
      border: "none",
      fontSize: "var(--font-size-medium)",
    },
    ariaProps: {
      role: "alert",
      "aria-live": "assertive",
    },
  });
};

export const notifyError = (
  message: string,
  position?: ToastPosition,
): string => {
  return toast.error(message, {
    duration: 3000,
    position: position ? position : "top-center",
    className: "toast-error",
    style: {
      backgroundColor: "var(--background-error-light)",
      color: "var(--secondary-black)",
      border: "none",
      fontSize: "var(--font-size-medium)",
    },
    ariaProps: {
      role: "alert",
      "aria-live": "assertive",
    },
  });
};

export const notifyInfo = (
  message: string,
  position?: ToastPosition,
): string => {
  return toast(message, {
    duration: 3000,
    position: position ? position : "top-center",
    icon: <InfoIcon />,
    className: "toast-info",
    style: {
      backgroundColor: "var(--page-background)",
      color: "var(--primary-black)",
      border: "1px solid var(--dark-gray)",
      fontSize: "var(--font-size-medium)",
    },
    ariaProps: {
      role: "alert",
      "aria-live": "assertive",
    },
  });
};
